export const priceRiseCalculatorToolState = {
  priceRise: {
    howMuch: null, // How much do you pay monthly for energy?
    cpiAmount: null, // from Glide optionsJson
    rpiAmount: null, // from Glide optionsJson
    providersList: null, // from Glide optionsJson
    providerSelected: { provider: '', multiplier: null, baseIndex: null }, // Which provider are you with?
  },
}
